import {Injectable, NgZone} from "@angular/core";
import {default as OneSignalPlugin} from "onesignal-cordova-plugin";
import {LiveActivitySetupOptions} from "onesignal-cordova-plugin/dist/models/LiveActivities";

@Injectable()
export class LiveActivities {
  constructor(private readonly ngZone: NgZone) {
  }

  /**
   * Enter a live activity
   */
  enter(activityId: string, token: string): Promise<any> {
    return this.ngZone.runOutsideAngular(() => new Promise<any>((resolve, reject) => {
      OneSignalPlugin.LiveActivities.enter(
        activityId,
        token,
        (result) => {
          this.ngZone.run(() => {
            resolve(result);
          });
        },
        (reason: any) => {
          this.ngZone.run(() => {
            reject(reason)
          })
        }
      );
    }));
  };

  /**
   * Exit a live activity
   */
  exit(activityId: string): Promise<any> {
    return this.ngZone.runOutsideAngular(() => new Promise<any>((resolve, reject) => {
      OneSignalPlugin.LiveActivities.exit(
        activityId,
        (result) => {
          this.ngZone.run(() => {
            resolve(result);
          });
        },
        (reason: any) => {
          this.ngZone.run(() => {
            reject(reason)
          })
        }
      );
    }));
  };


  /**
   * iOS Only.
   *
   * Indicate this device is capable of receiving pushToStart live activities for the
   * `activityType`. The `activityType` **must** be the name of the struct conforming
   * to `ActivityAttributes` that will be used to start the live activity.
   */
  setPushToStartToken(activityType: string, token: string): void {
    OneSignalPlugin.LiveActivities.setPushToStartToken(activityType, token);
  }

  /**
   * iOS Only.
   *
   * Indicate this device is no longer capable of receiving pushToStart live activities
   * for the `activityType`. The `activityType` **must** be the name of the struct conforming
   * to `ActivityAttributes` that will be used to start the live activity.
   */
  removePushToStartToken(activityType: string): void {
    OneSignalPlugin.LiveActivities.removePushToStartToken(activityType);
  }

  /**
   * iOS Only.
   *
   * Enable the OneSignalSDK to setup the default`DefaultLiveActivityAttributes` structure,
   * which conforms to the `OneSignalLiveActivityAttributes`. When using this function, the
   * widget attributes are owned by the OneSignal SDK, which will allow the SDK to handle the
   * entire lifecycle of the live activity.  All that is needed from an app-perspective is to
   * create a Live Activity widget in a widget extension, with a `ActivityConfiguration` for
   * `DefaultLiveActivityAttributes`. This is most useful for users that (1) only have one Live
   * Activity widget and (2) are using a cross-platform framework and do not want to create the
   * cross-platform <-> iOS native bindings to manage ActivityKit.
   */
  setupDefault(options?: LiveActivitySetupOptions): void {
    OneSignalPlugin.LiveActivities.setupDefault(options);
  }

  /**
   * iOS Only.
   *
   * Start a new LiveActivity that is modelled by the default`DefaultLiveActivityAttributes`
   * structure. The `DefaultLiveActivityAttributes` is initialized with the dynamic `attributes`
   * and `content` passed in.
   */
  startDefault(activityId: string, attributes: object, content: object): void {
    OneSignalPlugin.LiveActivities.startDefault(activityId, attributes, content);
  }
}
